export default [
    // {
    //     path: "gestion-planillas/reportes",
    //     name: "menu-reporte",
    //     component: () =>
    //       import("@/views/planilla/reporteria/views/MenuReportes.vue"),
    // },
    {
        path: "gestion-planillas/reportes/dinamicos",
        name: "reportes-dinamicos",
        component: () =>
          import("@/views/planilla/reporteria/views/Dinamicos.vue"),
    },
    {
      path: "gestion-planillas/reportes/dinamicos/crear",
      name: "crear-reporte-dinamico",
      component: () =>
        import("@/views/planilla/reporteria/views/ReporteDinamico.vue"),
    },
    {
      path: "gestion-planillas/reportes/planilla-unica",
      name: "reportes-planilla-unica",
      component: () =>
        import("@/views/planilla/reporteria/views/PlanillaUnica.vue"),
    },
    {
      path: "gestion-planillas/reportes/planilla-unica/detalles/:id",
      name: "reportes-detalle-planilla-unica",
      component: () =>
        import("@/views/planilla/reporteria/planillaUnica/views/DetallePlanillaUnica.vue"),
    },
    {
      path: "gestion-planillas/reportes/dinamicos/:id",
      name: "reporte-dinamico",
      component: () =>
        import("@/views/planilla/reporteria/views/ReporteDinamico.vue"),
    },
    {
      path: "gestion-planillas/reportes/general-personalizado",
      name: "reporte-general-personalizado",
      component: () =>
        import("@/views/planilla/reporteria/reporting/ReportingDinamico.vue"),
    },
    {
      path: "gestion-planillas/reportes/general-personalizado/:id",
      name: "reporte-general-personalizado-detalle",
      component: () =>
        import("@/views/planilla/reporteria/reporting/ReportingDinamico.vue"),
    },
    {
        path: "gestion-planillas/reportes/:id",
        name: "reporte",
        component: () =>
          import("@/views/planilla/reporteria/views/Personalizado.vue"),
    },
]
